import type { ReactElement } from 'react';

import {
  ScaleIconContentDataVisualisation,
  ScaleIconContentRoute,
  ScaleIconContentShop,
  ScaleIconContentTodoList,
  ScaleIconServiceSettings,
  ScaleIconUserFileContracts,
} from '@cloudorder/ui';

import type { NavGroupIcon } from '@/app/navigation';

/* The navigation label already says what the destination is, so the icon is
   decorative — it exists to give the eye a per-group anchor while scanning. */
export function GroupIcon({ name }: { readonly name: NavGroupIcon }): ReactElement {
  const props = { size: 16, decorative: true } as const;

  switch (name) {
    case 'doc':
      return <ScaleIconUserFileContracts {...props} />;
    case 'branch':
      return <ScaleIconContentRoute {...props} />;
    case 'catalog':
      return <ScaleIconContentShop {...props} />;
    case 'settings':
      return <ScaleIconServiceSettings {...props} />;
    case 'chart':
      return <ScaleIconContentDataVisualisation {...props} />;
    case 'queue':
      return <ScaleIconContentTodoList {...props} />;
  }
}
